import { useTranslation } from "react-i18next";

import { ISurveyLiveHistoryEntry } from "../../../../../@types/SurveyBuilder";
import { getLongFormattedDate } from "../../../../../utils/dateFormatter";
import {
  Container,
  Title,
} from "../../../../PatientPage/components/PatientLateralMenu/components/ConfirmChangesModal.styles";
import { MutedText } from "../../SurveyBuilder.styles";
import { HistoryList } from "./LiveHistoryModal.styles";

/** EN-5261: every change of the version patients answer, newest first. */
export function LiveHistoryModal({
  history,
}: {
  history: ISurveyLiveHistoryEntry[];
}) {
  const { t } = useTranslation();

  return (
    <Container>
      <Title>{t("surveys_builder_history_title")}</Title>
      {history.length === 0 ? (
        <MutedText>{t("surveys_builder_history_empty")}</MutedText>
      ) : (
        <HistoryList>
          {history.map((entry) => (
            <li key={`${entry.versionId}-${entry.changedAt}`}>
              <time dateTime={entry.changedAt}>
                {getLongFormattedDate(entry.changedAt)}
              </time>
              <span>
                {t(
                  entry.madeLiveAgain
                    ? "surveys_builder_history_madeLive"
                    : "surveys_builder_history_published",
                  { number: entry.versionNumber }
                )}
              </span>
              <MutedText>
                {entry.changedBy
                  ? t("surveys_builder_history_by", { name: entry.changedBy })
                  : ""}
              </MutedText>
            </li>
          ))}
        </HistoryList>
      )}
    </Container>
  );
}
